import { useState, useEffect } from 'react';
import Home from './pages/Home';
import Admin from './pages/Admin';
import Certificate from './pages/Certificate';

function App() {
  const [currentPage, setCurrentPage] = useState('home');

  useEffect(() => {
    // Check URL hash for routing
    const hash = window.location.hash.replace('#', '');
    if (hash === 'admin') {
      setCurrentPage('admin');
    } else if (hash === 'certificate') {
      setCurrentPage('certificate');
    } else {
      setCurrentPage('home');
    }

    // Listen for hash changes
    const handleHashChange = () => {
      const newHash = window.location.hash.replace('#', '');
      if (newHash === 'admin') {
        setCurrentPage('admin');
      } else if (newHash === 'certificate') {
        setCurrentPage('certificate');
      } else {
        setCurrentPage('home');
      }
    };

    window.addEventListener('hashchange', handleHashChange);
    return () => window.removeEventListener('hashchange', handleHashChange);
  }, []);

  const navigateTo = (page) => {
    window.location.hash = page;
  };

  if (currentPage === 'certificate') {
    return <Certificate onBack={() => navigateTo('')} />;
  }

  if (currentPage === 'admin') {
    return <Admin onLogout={() => navigateTo('')} />;
  }

  return <Home onAdminClick={() => navigateTo('admin')} />;
}

export default App;